import { Switch } from "@mui/material";
import { Controller, Path, useFormContext } from "react-hook-form";
import { TbEye, TbEyeOff } from "react-icons/tb";

import { CreatePassengerForm } from "./CreateCustomPassengerDialog";

function CreatePassengerWelcomeTeamVisibility({
    formBasePath,
    showToWelcomeTeam,
}: {
    formBasePath: "step2.arrival.info" | "step2.departure.info";
    showToWelcomeTeam: boolean;
}) {
    const { control } = useFormContext<CreatePassengerForm>();

    return (
        <div className=" grid grid-cols-8 col-span-full gap-5  py-2">
            <div className="flex col-span-full p-2   items-center justify-between rounded-t-lg border-b bg-gray-100 ">
                <div className="space-y-0.5 flex items-center gap-2">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10">
                        {showToWelcomeTeam ? <TbEye className="h-4 w-4 " /> : <TbEyeOff className="h-4 w-4 " />}
                    </div>
                    <div>
                        <div className="text-base font-medium">Karşılama Ekibi görünürlüğü </div>
                        <p className="text-[13px] text-gray-500">
                            Yolcu bilgisini Karşılama ekibine göstermek için bu seçeneği etkinleştirebilirsiniz.
                        </p>
                    </div>
                </div>
                <Controller
                    name={(formBasePath + ".showToWelcomeTeam") as Path<CreatePassengerForm>}
                    control={control}
                    render={({ field }) => (
                        <Switch
                            {...field}
                            checked={!!field.value}
                            onChange={(e) => {
                                field.onChange(e.target.checked);
                            }}
                        />
                    )}
                />
            </div>
        </div>
    );
}

export default CreatePassengerWelcomeTeamVisibility;
